<template lang="pug">
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/basic
div(class="border-bottom insety-16 industry-select")
    ib-row(:class="{ 'pb-16': !$media.xl }")
        ib-col(class="xl2 s12")
            p(:class="{'insety-16': $media.xl, 'insetx-8': $media.xl}")
                span(
                    class="insetx-8 info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('select_from_industries') }}
                span {{ $t('industry') }}
        ib-col(
            class="flex xl3 pb-0",
            :class="{ 'inset-16': $media.xl, 'insety-16': $media.s, 'insetx-16': $media.xl, 'insetx-0': !$media.m }"
        )
            ib-button(
                @click="setAllActive",
                :class="{active: selectAll }",
                class="text-bold after-8 text-left"
            ) {{ $t('select_all') }}
                span(
                    v-if="selectAll",
                    class="inset-8",
                    :class="{'fg-positive': selectAll }"
                )
                    +icon-color-yes
            ib-button(
                v-for="(sector, index) in enabledSectors.slice(0,3)",
                :key="index",
                class="after-8 text-left",
                @click="select(index)",
                :class="{active: sector.selected }"
            )
                span {{ $t(sector.name) }}
                span(
                    v-if="sector.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
        ib-col(
            class="flex xl3 pb-0",
            :class="{ 'inset-16': $media.xl, 'insetx-16': $media.xl, 'insetx-0': !$media.m }"
        )
            ib-button(
                v-for="(sector, index) in enabledSectors.slice(3,7)",
                :key="index",
                class="after-8 text-left",
                @click="select(index+3)",
                :class="{active: sector.selected }"
            )
                span {{ $t(sector.name) }}
                span(
                    v-if="sector.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
        ib-col(
            class="flex xl3 pb-0",
            :class="{ 'inset-16': $media.xl, 'insetx-16': $media.xl, 'insetx-0': !$media.m }"
        )
            ib-button(
                v-for="(sector, index) in enabledSectors.slice(7)",
                :key="index",
                class="after-8 text-left",
                @click="select(index+7)",
                :class="{active: sector.selected }"
            )
                span {{ $t(sector.name) }}
                span(
                    v-if="sector.selected",
                    class="inset-8 fg-positive"
                )
                    +icon-color-yes
</template>
<script>
    import cloneDeep from 'lodash.clonedeep';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'IndustryType',

        components: {
        },

        data() {
            return {
            }
        },

        methods: {
            select(index) {
                const newSector = cloneDeep(this.enabledSectors[index]);
                newSector.selected = !newSector.selected;
                this.setSector({index, sector: newSector});
            },
            setAllActive() {
                let all = cloneDeep(this.sectors);
                if (this.selectAll) {
                    all.forEach(item => item.selected = false);
                } else {
                    all.forEach(item => item.selected = true);
                }
                this.setSectors(all);
            },
            ...mapActions(['setSectors', 'setSector'])
        },
        computed : {
            enabledSectors: function() {
                return this.sectors.filter(item => !item.disabled);
            },
            selectAll: function() {
                return this.enabledSectors.filter(item => item.selected).length === this.enabledSectors.length
            },
            ...mapState(['sectors'])
        },
    }
</script>

<style lang="less">
    .industry-select {
        .pb-16 {
            padding-bottom: 16px;
        }
        .pb-0 {
            padding-bottom: 0;
        }
        button {
            &::after {
                background-color: white;
            }
            svg {
                float: right;
            }
            &:hover {
                border-color: #000;
                span {
                    color: #000;
                }
            }
        }
    }
    @media (max-width: 600px) {
        .industry-select {
            .pb-0 {
                padding-bottom: 0;
            }
            button {
                margin: 2px 0;
            }
        }
    }
</style>
